
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Timelines } from '@clients/bff';
import StatisticEntryView from './StatisticEntryView.vue';
import StatisticFrequency from '@/models/statistic/StatisticFrequency';
import StatisticAttribute from '@/models/statistic/StatisticAttribute';
import { namespace } from 'vuex-class';
import { isNullOrUndefined } from 'util';

const StatisticModule = namespace('Statistic');
const TriplogModule = namespace('Triplog');

@Component({
  name: 'TimelinesTab',
  components: {
    StatisticEntryView,
  },
})
export default class TimelinesTab extends Vue {
  @Prop()
  private timelines: Timelines;

  @StatisticModule.Getter('getTimelineSelection')
  private timelineSelection;

  @StatisticModule.Mutation('SET_TIMELINE_FREQUENCY_SELECTION')
  private setFrequencySelection;

  @StatisticModule.Mutation('SET_TIMELINE_ATTRIBUTE_SELECTION')
  private setAttributeSelection;

  @TriplogModule.Getter('getFuelUnit')
  private fuelUnit: string;

  get frequencySelection(): StatisticFrequency {
    return this.timelineSelection.frequency;
  }

  get attributeSelection(): StatisticAttribute {
    return this.timelineSelection.attribute;
  }

  get entries() {
    return this.timelines[this.frequencySelection][this.attributeSelection];
  }

  get showSmartConnectInfo() {
    return !isNullOrUndefined(this.timelines[this.frequencySelection].ecoScore);
  }

  onFrequencyChange(e) {
    this.setFrequencySelection(e.target.value);
  }

  onAttributeChange(e) {
    this.setAttributeSelection(e.target.value);
  }
}
